export enum UserProfileType {
	ANY = 'any',
	COACH = "coach",
	ATHLETE = "athlete",
}